import { useSelector } from "react-redux";
import { FilterTemplate } from "./FilterTemplate";

interface TouchpointFilterProps {
	innerRef: React.RefObject<{
		getFilters: () => string[];
	}>;
	handleApply: () => void;
}

export const TouchpointFilter: React.FC<TouchpointFilterProps> = ({ innerRef, handleApply }) => {
	const touchpoints = useSelector(({ libraries }) => libraries?.touchPoint || [])?.sort((a, b) => a.name.localeCompare(b.name));

	return <FilterTemplate innerRef={innerRef} records={touchpoints} title="TOUCHPOINTS" icon="circle-dot" handleApply={handleApply} />;
};
